export default function CartButton({itemInCart, cartActive, _classes, cart, product}) {

  return (
    <>
     {cartActive && 
           <button
             className={_classes ? _classes : "lexcms-large-button lexcms-add-product-button" }
             onClick={() => itemInCart ? cart.removeItem(product.id) :  cart.addItem(product.id) } 
           >
             {itemInCart ? '- Remove Product' : '+ Save Product'}
           </button>
        }
    </>
  )


}
